// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".new-data-hint[data-v-611d4b1d]{cursor:pointer;margin-top:10px}", "",{"version":3,"sources":["webpack://./resources/js/Pages/Administrations/CronJobs/Executions.vue"],"names":[],"mappings":"AACA,gCAEI,cAAA,CADA,eACA","sourcesContent":["\n.new-data-hint {\n    margin-top: 10px;\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
